import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import ClientSelect from '../ClientSelect';
import CompanySelect from '../CompanySelect';
import AdditionalControlsInputLabel from './AdditionalControlsInputLabel';

const AdditionalAgencyControls = ({ clients, agencies, shouldUnregister }) => {
  const { control } = useFormContext();

  return (
    <>
      <hr className='-mx-[32px] mt-8 mb-4' />
      <div className='mb-4'>
        <Typography id='agency-controls-title' variant='h5' component='div'>
          Agency
        </Typography>
        <span className='text-[#777E90] text-[12px]'>Assign the Client and advertiser to this user</span>
      </div>
      <div className='mb-3'>
        <AdditionalControlsInputLabel id='agency-client-select-label'>
          What Client does this agency user belong to?
        </AdditionalControlsInputLabel>
        <Controller
          name='client'
          shouldUnregister={shouldUnregister}
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please select a Client.',
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <ClientSelect
              {...field}
              labelId='agency-client-select-label'
              id='agency-client-select'
              options={clients}
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </div>
      <div className='mb-3'>
        <AdditionalControlsInputLabel id='agency-agency-select-label'>
          Which Agency does this user belong to?
        </AdditionalControlsInputLabel>
        <Controller
          name='agency'
          shouldUnregister={shouldUnregister}
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please select an Agency.',
            },
          }}
          defaultValue=''
          render={({ field, fieldState: { error } }) => (
            <CompanySelect
              {...field}
              labelId='agency-agency-select-label'
              id='agency-agency-select'
              options={agencies}
              placeholder='Select Agency'
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </div>
    </>
  );
};

AdditionalAgencyControls.propTypes = {
  clients: PropTypes.array,
  agencies: PropTypes.array,
  shouldUnregister: PropTypes.bool,
};

export default AdditionalAgencyControls;
